module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (122).846c2387.jpg";